import PropTypes from "prop-types";
import { STOCK_STATUS_META } from "../../../constants/promotedProducts";

/**
 * Renders the stock status exactly as the API reports it.
 * The label prefers `stock_status_label` from the server; the local map is
 * only a fallback. The status is NEVER recomputed client-side.
 */
const StockStatusBadge = ({ status, label }) => {
  const meta = STOCK_STATUS_META[status];

  if (!meta) {
    return <span className="badge badge-soft-secondary">{label || "—"}</span>;
  }

  return (
    <span className={meta.badgeClass}>
      <i
        className="ri-circle-fill me-1"
        style={{ fontSize: 8, color: meta.dotColor }}
      />
      {label || meta.label}
    </span>
  );
};

StockStatusBadge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
};

export default StockStatusBadge;
